import { noop } from "lodash";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  reactQueryGet,
  reactQueryPatch,
} from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import { usePunditUserContext } from "@circle-react/contexts";
import type { CommunitySettings } from "@circle-react/types/CommunitySettings";

const REQUEST_KEY = ["community-setting", "show"];

export const useCommunitySettingShow = () =>
  useQuery(REQUEST_KEY, () => {
    const url = internalApi.communities.communitySettings.index();
    return reactQueryGet<{ community_settings: CommunitySettings }>(url);
  });

const updateCommunitySettings = ({ data, updates }: any) => {
  const url = internalApi.communities.communitySettings.update({
    communitySettingId: data.community_settings.id,
  });

  const payload = { community_setting: updates };

  return reactQueryPatch(url, payload);
};

export const useUpdateCommunitySetting = ({
  onMutate = noop,
  onSuccess = noop,
  onError = noop,
  onSettled = noop,
} = {}) => {
  const { refetch } = usePunditUserContext();
  const queryClient = useQueryClient();

  return useMutation(updateCommunitySettings, {
    onMutate: ({ data }) => {
      const previousData = queryClient.getQueryData(REQUEST_KEY);
      queryClient.setQueryData(REQUEST_KEY, data);
      onMutate && onMutate();
      return { previousData, data };
    },
    onSuccess: async data => {
      await refetch();
      queryClient.setQueryData(REQUEST_KEY, data);
      onSuccess && onSuccess();
    },
    onError: onError,
    onSettled: onSettled,
  });
};
